import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { getInvitationsQueryKey } from "../lib/invitationsQuery"

export function useResendInvitationMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ id }: { id: string }) => {
      const { data } = await axios.post(`/employees/invitations/${id}/resend`)
      return data.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getInvitationsQueryKey() })
    },
  })
}
